const RaffleRecord = () => import('@/views/main/raffle/raffleRecord/RaffleRecord.vue')
export default {
  path: '/main/raffle/raffleRecord',
  name: 'RaffleRecord',
  component: RaffleRecord
}
